// extracted by mini-css-extract-plugin
export default {"fieldPadding":"ClassDetails_fieldPadding__-i8KS","viewProjects":"ClassDetails_viewProjects__Ai-gV","viewProjectButton":"ClassDetails_viewProjectButton__7Pas9"};